import isBoolean from "lodash/isBoolean";
import { View } from "../../../../api/api";
import { types } from "./Keypad.actions";
import { IGameSetting } from "./Keypad.actions";
import { types as v2Types } from "../../../../v2/redux/types";
import { has } from "lodash";

export interface IKeypadStateProps {
  hidden?: boolean;
  volume: number;
  muted: boolean;
  autoplayAvailable: boolean;
  autoplayButtonDisabled?: boolean;
  spinStarted: boolean;
  isFullscreenGame: boolean;
  isLeftHandMode: boolean;
  isPlayingForFun: boolean;
  gameSettings: IGameSetting[];
  menuButtonDisabled?: boolean;
  spinButtonDisabled?: boolean;
  betButtonDisabled?: boolean;
  soundButtonDisabled?: boolean;
  quickSpin: {
    available?: boolean;
    enabled?: boolean;
    active?: boolean;
  };
}

const defaultState: IKeypadStateProps = {
  hidden: false,
  volume: 1,
  muted: false,
  autoplayAvailable: false,
  isFullscreenGame: false,
  spinStarted: false,
  isLeftHandMode: false,
  isPlayingForFun: false,
  gameSettings: [],
  quickSpin: {
    available: false,
    enabled: false,
    active: false
  }
};

export const keypad = (state = defaultState, action) => {
  const buttonState = {};

  switch (action.type) {
    case v2Types.SET_STATE: {
      const next = { ...state };
      if (has(action.value, "view")) {
        switch (action.value.view) {
          case View.DEFAULT:
          case View.PAYTABLE:
          case View.GAME_RULES:
          case View.GAME_HISTORY:
          case View.MAIN_SETTINGS:
          case View.BET_SETTINGS:
          case View.AUTOPLAY_SETTINGS:
            return {
              ...next,
              hidden: false
            };

          case null:
            return {
              ...next,
              hidden: true
            };
          default:
            return next;
        }
      }

      return next;
    }

    case types.SOUND_MUTE:
      return {
        ...state,
        muted: action.value
      };

    case types.SET_VOLUME:
      return {
        ...state,
        volume: action.value
      };

    case types.START_SPIN:
      return {
        ...state,
        spinStarted: true
      };

    case types.STOP_SPIN:
      return {
        ...state,
        spinStarted: false
      };

    case types.ENABLE_KEYPAD_BUTTON:
      buttonState[`${action.button}ButtonDisabled`] = false;
      return {
        ...state,
        ...buttonState
      };

    case types.DISABLE_KEYPAD_BUTTON:
      buttonState[`${action.button}ButtonDisabled`] = true;
      return {
        ...state,
        ...buttonState
      };

    case types.SET_LEFT_HAND_MODE_ACTIVE:
      return {
        ...state,
        isLeftHandMode: isBoolean(action.value)
          ? action.value
          : state.isLeftHandMode
      };

    case types.SET_FULLSCREEN_CANVAS_ACTIVE:
      return {
        ...state,
        isFullscreenGame: isBoolean(action.value)
          ? action.value
          : state.isFullscreenGame
      };

    case types.SET_PLAY_FOR_FUN_ACTIVE:
      return {
        ...state,
        isPlayingForFun: isBoolean(action.value)
          ? action.value
          : state.isPlayingForFun
      };

    case types.SET_GAME_SETTINGS:
      return {
        ...state,
        gameSettings: action.settings.map(({ key, value, name }) => ({
          key,
          value,
          name
        }))
      };

    case types.SET_QUICKSPIN_AVAILABLE:
      return {
        ...state,
        quickSpin: {
          ...state.quickSpin,
          available:
            typeof action.value === "boolean"
              ? action.value
              : state.quickSpin.available
        }
      };
    case types.SET_QUICKSPIN_ENABLED:
      return {
        ...state,
        quickSpin: {
          ...state.quickSpin,
          enabled: action.value
        }
      };
    case types.SET_QUICKSPIN_ACTIVE:
      return {
        ...state,
        quickSpin: {
          ...state.quickSpin,
          active: action.value
        }
      };
    default:
      return state;
  }
};
